import React from "react";
import {
  Box,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
  CardContent,
  Card,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import { useCheckout } from "./CheckoutContext";

const Account = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { user, logout } = useAuth();
  console.log(user);
  const { state: checkoutState, orders } = useCheckout();
  const { shippingDetails } = checkoutState;
  const defaultCountry = Array.isArray(shippingDetails)
    ? shippingDetails.find((address) => address.isDefault)
    : null;

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  // Redirect if not authenticated
  if (!user) {
    navigate("/login");
    return null;
  }

  return (
    <Box
      sx={{
        maxWidth: 1200,
        mx: "auto",
        mt: isMobile ? 18 : 20,
        px: isMobile ? 2 : 3,
        height: isMobile ? "auto" : "80vh",
        pb: isMobile ? 4 : 0,
      }}
    >
      <Grid container justifyContent="space-between" alignItems="flex-start">
        {/* Left Column */}
        <Grid item>
          <Typography variant="h6" gutterBottom>
            MY ACCOUNT
          </Typography>
          <Typography
            sx={{
              display: "block",
              mt: 2,
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={handleLogout}
          >
            Log out
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 8 }}>
            ORDER HISTORY
          </Typography>
          {orders && orders.length > 0 ? (
            orders
              .slice()
              .reverse()
              .map((order) => (
                <Card
                  key={order.id}
                  sx={{
                    mt: 2,
                    boxShadow: 2,
                    borderRadius: 2,
                    backgroundColor: "#fafafa",
                  }}
                >
                  <CardContent>
                    <Typography variant="body1" fontWeight="bold">
                      Order ID: {order.id}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      Total: ₹{order.total}
                    </Typography>
                    <Typography variant="body2">
                      Status: {order.status}
                    </Typography>
                    <Typography variant="body2">
                      Date: {new Date(order.date).toLocaleString()}
                    </Typography>
                    <Typography variant="body2">
                      Items: {order.items?.length || 0}
                    </Typography>
                  </CardContent>
                </Card>
              ))
          ) : (
            <Typography sx={{ mt: 2 }}>
              You haven't placed any orders yet.
            </Typography>
          )}
        </Grid>

        {/* Right Column */}
        <Grid item>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontSize: isMobile ? "1.1rem" : "1.25rem",
              fontWeight: 500,
              mt: isMobile ? 5 : 0,
            }}
          >
            ACCOUNT DETAILS
          </Typography>
          <Typography sx={{ mb: 3, mt: 2 }}>
            {user?.name || user?.email || "User"}
          </Typography>
          <Typography>{user?.name || user?.email || "User"}</Typography>
          <Typography>{defaultCountry?.country || "India"}</Typography>

          <Typography
            sx={{
              display: "block",
              mt: 4,
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => navigate("/account/addresses")}
          >
            View addresses ({shippingDetails?.length || 0})
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Account;
